import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsStandUpPaddlingNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.278 12.331a1.249 1.249 0 00-.778-1.007V2.5H5v-1H3v1h.5v8.87a1.23 1.23 0 00-.7.925l-.228 1.525a1.461 1.461 0 102.895.04l-.19-1.529zm-.915 2.013a.471.471 0 01-.7 0 .451.451 0 01-.106-.369l.23-1.525a.249.249 0 01.495.007l.189 1.531a.457.457 0 01-.108.356zM9.5 6.368a1.482 1.482 0 00-1.351 1.691c.102 1.255.402 2.487.887 3.649l.132.309h.668l.128-.309c.485-1.162.784-2.394.887-3.649A1.483 1.483 0 009.5 6.368zM9.5 10a7.45 7.45 0 01-.351-1.938c0-.587.245-.68.359-.69.05 0 .343.054.343.69A7.45 7.45 0 019.5 10z"
        fill=""
      />
      <path
        d="M11.281 1.528a2.07 2.07 0 00-3.562 0A8.934 8.934 0 006.5 6.023c0 2.375.333 4.739.988 7.022l.484 1.683a1.076 1.076 0 001.036.773h.984a1.077 1.077 0 001.036-.772l.484-1.685c.655-2.283.988-4.646.988-7.021a8.934 8.934 0 00-1.219-4.495zm-.73 11.241L9.992 14.5l-1.059-.048-.484-1.684A24.465 24.465 0 017.5 6.023a7.935 7.935 0 011.083-3.992 1.072 1.072 0 011.834 0A7.944 7.944 0 0111.5 6.023c0 2.282-.32 4.553-.949 6.746z"
        fill=""
      />
    </svg>
  )
);
SvgSportsStandUpPaddlingNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsStandUpPaddlingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsStandUpPaddlingNormalXsmall;
